/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPMIMETYPE } from './IAPMIMETYPE';
import {
    IAPMIMETYPEFromJSON,
    IAPMIMETYPEFromJSONTyped,
    IAPMIMETYPEToJSON,
} from './IAPMIMETYPE';

/**
 * 
 * @export
 * @interface ContentManagerSingleDocumentViewModel
 */
export interface ContentManagerSingleDocumentViewModel {
    /**
     * 
     * @type {string}
     * @memberof ContentManagerSingleDocumentViewModel
     */
    base64: string;
    /**
     * 
     * @type {string}
     * @memberof ContentManagerSingleDocumentViewModel
     */
    fileName: string;
    /**
     * 
     * @type {IAPMIMETYPE}
     * @memberof ContentManagerSingleDocumentViewModel
     */
    mimeType: IAPMIMETYPE;
    /**
     * 
     * @type {string}
     * @memberof ContentManagerSingleDocumentViewModel
     */
    itemId: string;
}

/**
 * Check if a given object implements the ContentManagerSingleDocumentViewModel interface.
 */
export function instanceOfContentManagerSingleDocumentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "base64" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "mimeType" in value;
    isInstance = isInstance && "itemId" in value;

    return isInstance;
}

export function ContentManagerSingleDocumentViewModelFromJSON(json: any): ContentManagerSingleDocumentViewModel {
    return ContentManagerSingleDocumentViewModelFromJSONTyped(json, false);
}

export function ContentManagerSingleDocumentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentManagerSingleDocumentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'base64': json['Base64'],
        'fileName': json['FileName'],
        'mimeType': IAPMIMETYPEFromJSON(json['MimeType']),
        'itemId': json['ItemId'],
    };
}

export function ContentManagerSingleDocumentViewModelToJSON(value?: ContentManagerSingleDocumentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Base64': value.base64,
        'FileName': value.fileName,
        'MimeType': IAPMIMETYPEToJSON(value.mimeType),
        'ItemId': value.itemId,
    };
}

